import { lazy } from "react"

import { COMPANY_BASE_ROLES_VALUES } from "@/shared/constants"
import type { CustomRoute } from "@/shared/types"

const AuditorProfilePage = lazy(async () => import("@/pages/dashboard/auditor-portfolio/auditor-profile"))

export const auditorPortfolioRoutes: CustomRoute = {
  path: "auditor-profile",
  handle: {
    hide: true,
    allowedRoles: COMPANY_BASE_ROLES_VALUES
  },
  Component: AuditorProfilePage
}
